<template>
  <modal @close="close" width="60%">
    <h3 slot="header">Cotización</h3>

    <template slot="body">
      <md-card class="md-accent">
        <md-card-content class="md-layout">
          <f-field label="Folio" :value="quotation.folio" />
          <f-field label="Autopista" :value="quotation.highwayName" />
          <f-field label="Campamento" :value="quotation.campName" />
          <f-field label="Recibe" :value="quotation.receive.name" />
        </md-card-content>
      </md-card>

      <md-table
        md-card
        :value="supplies"
        class="table-striped table-hover md-layout-item md-size-100"
      >
        <template slot="md-table-row" slot-scope="{ item }">
          <supply-row :supply="item" :campId="quotation.camp.id"></supply-row>
        </template>
      </md-table>
    </template>

    <template slot="footer">
      <md-button @click="saveQuotation" class="md-primary" :disabled="sendDisabled">
        <md-progress-spinner :md-diameter="20" v-if="sending" md-mode="indeterminate"></md-progress-spinner>
        {{ sending ? "Enviando" : "Enviar" }}
      </md-button>
      <md-button @click="close">Cancelar</md-button>
    </template>
  </modal>
</template>

<script>
import FField from "./FField";
import QuotationSupplyRow from "./QuotationSupplyRow";
import purchaseService from "@/services/purchase";

export default {
  name: "EditQuotation",

  props: {
    quotation: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  components: {
    FField,
    SupplyRow: QuotationSupplyRow,
  },

  methods: {
    close() {
      this.$emit("close");
    },
    saveQuotation() {
      this.sending = true;
      purchaseService
        .sendMaterialQuotation(this.quotation.id, this.supplies)
        .then(() => {
          this.$emit("saved", this.quotation);
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.sending = false));
      // this.$emit('close')
    },
    makeSupplyProviders(supplies) {
      const supplyProviders = {};

      for (const supply of supplies) {
        supplyProviders[supply.id] = [];
        purchaseService.fetchSupplyHighwaySupplies(supply).then((hsupplies) => {
          const providers = hsupplies.map((s) => s.provider);
          supplyProviders[supply.id] = providers;
        });
      }

      this.supplyProviders = supplyProviders;
    },
  },

  created() {
    this.supplies = this.quotation.supplies.map((s) => {
      return {
        ...s,
        providerId: null,
      };
    });
    // this.makeSupplyProviders(this.quotation.supplies)
  },

  watch: {
    quotation: {
      inmediate: true,
      handler(quotation) {
        makeSupplyProviders(quotation.supplies);
      },
    },
  },

  computed: {
    sendDisabled() {
      return this.sending || !this.allProvidersSet;
    },
    allProvidersSet() {
      return this.supplies.filter((s) => !s.providerId).length === 0;
    },
  },

  data() {
    return {
      providers: [{ id: 1, name: "none" }],
      supplyProviders: {},
      sending: false,
      supplies: null,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/Quotations/Edit.vue